import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { DirectivesModule } from 'directives/directives.module';
import { EditWorkoutsPage } from './edit-workouts-page';
import { PagesModule } from 'pages/pages.module';

@NgModule({
  declarations: [EditWorkoutsPage],
  imports: [PagesModule, ComponentsModule, DirectivesModule]
})
export class EditWorkoutsPageModule { }
